export const addressReduction = (address, number) => {
    let addressPartSecond = address.split("").splice(address.length - 4, address.length).join("")
    let addressPartFirst = address.split("").splice(0, number).join("")

    return addressPartFirst + "..." + addressPartSecond
}